var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[(_vm.error === false)?_c('div',[_vm._v(" Logging in... ")]):_c('div',[_vm._v(" Something went wrong. "),_c('a',{attrs:{"href":"/"}},[_vm._v("Go home")]),_vm._v(". ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }